"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CellSummaryStatusBarSubPanelPopover = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const CellSummaryDetails_1 = require("./CellSummaryDetails");
const react_redux_1 = require("react-redux");
const CellSummaryStatusBarSubPanelPopover = () => {
    const cellSummary = (0, react_redux_1.useSelector)((state) => state.Grid.CellSummary);
    const summary = React.createElement(CellSummaryDetails_1.CellSummaryDetails, { CellSummary: cellSummary });
    return cellSummary && cellSummary.Count ? (summary) : (
    // the extra wrapper is added because the empty text is rendered
    // inside a  EmptyContent, hat has position absolute
    React.createElement("div", { style: { position: 'relative', width: '100%', height: 80 } }, summary));
};
exports.CellSummaryStatusBarSubPanelPopover = CellSummaryStatusBarSubPanelPopover;
